import { createFileRoute } from "@tanstack/react-router";

import OAuthCompletePage from "@/features/auth/pages/oauth-complete";
import { AuthProvider } from "@/providers/auth.provider";

// Tokens arrive in the URL FRAGMENT (#accessToken=...), which the router never sees - no
// validateSearch needed; the page reads location.hash directly.
export const Route = createFileRoute("/(auth)/oauth/complete")({
  component: () => (
    <AuthProvider>
      <main role="main" aria-label="Google sign-in completion page" className="min-h-screen w-full">
        <OAuthCompletePage />
      </main>
    </AuthProvider>
  ),
});
